import React from 'react'

var EventCategory = React.createClass({
  propTypes: {
    onChange: React.PropTypes.func.isRequired,
    label: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
    member_validation_required: React.PropTypes.bool,
    admin: React.PropTypes.bool
  },
  render: function() {
    const { onChange, label, name, selected } = this.props;
    return(
      <div className="form-group">
        <div className="col-lg-2 text-right">
          <input type="radio" name="category" value={name} id={'category-'+name} onChange={onChange.bind(null, { 'category' : name })} checked={selected} />
        </div>
        <label className="col-lg-10" htmlFor={'category-'+name}>
          { label }
        </label>
      </div>
    );
  }
});

export default EventCategory;


// WEBPACK FOOTER //
// ./src/components/event_category.js